var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-header-wrapper',[(!_vm.merchantId)?_c('a-alert',{staticStyle:{"margin-bottom":"16px"},attrs:{"type":"warning","show-icon":"","message":_vm.$t('请从商家列表进入佣金设置')}}):_vm._e(),(_vm.merchantId)?_c('commission-settings',{key:_vm.merchantId,attrs:{"merchant-id":_vm.merchantId}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }